<div class="modal-body p-0">
  <iframe [src]="src | safe : 'resourceUrl'"
          class="d-block rounded border-0"
          style='width:100%;height:85vh;'>
  </iframe>
</div>
